import { useI18n } from 'vue-i18n';
import { ToastService } from '@/shared/utilities/feedback/toast-service';

export function useToastService() {
  const { t } = useI18n({ useScope: 'global' });
  ToastService.setTranslator(t);

  return {
    success: ToastService.success.bind(ToastService),
    info: ToastService.info.bind(ToastService),
    warn: ToastService.warn.bind(ToastService),
    error: ToastService.error.bind(ToastService),
    exception: ToastService.exception.bind(ToastService),
  };
}
